module.exports = __webpack_public_path__ + "img/p4_1.c00762e8.png";